import Api from "@pga/axios-service";
import { Login_Route } from "routes/handleRoutes/routesVar";
import AccountUrls from "services/authontication/urls";
export const ApiInstance = (
  notRequireAuth: boolean = false,
  signal?: AbortSignal,
  baseURL?: string,
  callExportGrid?: boolean
) => {
  return Api(
    notRequireAuth,
    signal,
    baseURL,
    callExportGrid,
    AccountUrls.getAccessToken,
    Login_Route
  );
};
